import React, { Fragment } from 'react';
import styles from './FinanceCalculatorSteps.module.scss';
import arrow from '../../../../../assets/icons/double-arrow.svg';

const Steps = ({ activeStep, onStepChange }) => {
  const steps = [
    { id: 1, label: 'SELECT MODEL' },
    { id: 2, label: 'FINANCE CALCULATOR' },
  ];

  return (
    <div className={styles.steps} data-aos="fade-up" data-aos-delay="500">
      {steps.map((step, index) => (
        <Fragment key={step.id}>
          <div
            className={`${styles.step} ${activeStep === step.id ? styles.active : ''}`}
            onClick={() => onStepChange(step.id)}
          >
            <div className={`${styles.stepCircle} ${activeStep === step.id ? styles.active : ''}`}>
              <p className={`${styles.stepNumber} ${activeStep === step.id ? styles.active : ''}`}>
                {step.id}
              </p>
            </div>
            <span className={`${styles.stepText} ${activeStep === step.id ? styles.active : ''}`}>
              {step.label}
            </span>
          </div>
          {index < steps.length - 1 && (
            <div className={styles.arrow}>
              <img src={arrow} alt="double-arrow" />
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default Steps;
